













































































































































































































































































import { Vue, Component } from 'vue-property-decorator'
import { ISearchRes } from '@/api/files/files-search/res'
import { Form } from 'element-ui'
import { resetObjValue2NoneString } from '@/utils/tool'
import {
  getSearchList,
  getSearchCategory,
  addSearch,
  deleteSearch,
  updateWeight
} from '@/api/files/files-search/filesSearch'
import { mixins } from 'vue-class-component'
import DateOption from '@/mixins/dateOption'
import { getChaos, getCookie, getImgURLOfBase64 } from '@/utils/fix'

@Component({
  name: 'FilesSearchIos'
})
export default class extends mixins(DateOption) {
  // data
  private params = {
    isIos: false,
    ids: '',
    from: 'us',
    updateDateStart: '',
    updateDateEnd: '',
    page: 1,
    pageCount: 5
  }
  private addParams = {
    ids: '',
    from: [],
    isIos: false
  }
  private editParams = {
    ids: '',
    from: '',
    weightLevel: '',
    weight: '',
    isIos: false
  }
  private deleteParams = {
    ids: '',
    from: '',
    isIos: false
  }
  private weight: string = ''
  private tableData: ISearchRes[] = []
  private selectedData: ISearchRes[] = []
  private totalCount: number = 0
  routeQuery: IQuery = { id: 0 }
  private addFormVisible: boolean = false
  private editFormVisible: boolean = false
  private dateArray: string[] = ['', '']
  private typeList: object[] = []
  private rules: any = {
    ids: [{ required: true, message: '请输入id', trigger: 'blur' }],
    from: [{ required: true, message: '请选择类别', trigger: 'change' }],
    weightLevel: [{ required: true, message: '请选择类别', trigger: 'change' }]
  }
  tableLoading = false
  openWindow: any
  tableHeight: number = 500
  // lifecycle
  created() {
    this.getTableData()
    this.getSearchCategory()
    this.$nextTick(() => {
      this.setTableHeight()
      window.addEventListener('resize', this.setTableHeight)
    })
  }
  beforeDestroy() {
    window.removeEventListener('resize', this.setTableHeight)
  }
  // methods
  async getTableData() {
    this.tableLoading = true
    let res = await getSearchList(this.params)
    let dataList = res.data.dataList || []
    let buildEnv = process.env.VUE_APP_ENV || ''
    if (buildEnv !== 'env') {
      this.tableData = dataList
      this.tableLoading = false
      this.totalCount = res.data.pageInfo.totalCount
      return false
    }
    this.tableData = []
    await getChaos()
    let header = {
      abc: getCookie('abc')
    }
    this.tableLoading = false
    const cover: string = require('@/assets/images/loading.svg')
    dataList.forEach((item: any) => {
      let el = { ...item }
      el.icon = cover
      this.tableData.push(el)
    })
    this.totalCount = res.data.pageInfo.totalCount
    for (let i = 0; i < dataList.length; i++) {
      getImgURLOfBase64(dataList[i].icon, header).then(res => {
        this.tableData[i]['icon'] = res as string
      })
    }
    this.tableLoading = false
    this.totalCount = res.data.pageInfo.totalCount
  }
  async getSearchCategory() {
    let res: any = await getSearchCategory({
      isIos: false
    })
    this.typeList = res.data
  }
  async addSearch() {
    let res: any = await addSearch({
      ids: this.addParams.ids,
      from: this.addParams.from.join(','),
      isIos: this.addParams.isIos
    })
    if (res.status.code === 0) {
      this['$message'].success('添加成功!')
      this.cancelAddForm()
    } else {
      this['$message'].error('添加失败!')
    }
  }
  async updateWeight(w: number | string) {
    let res: any = await updateWeight({
      ids: this.editParams.ids,
      from: this.editParams.from,
      weightLevel: this.editParams.weightLevel,
      weight: Number(this.editParams.weightLevel) === 1 ? w : 0,
      isIos: false
    })
    if (res.status.code === 0) {
      this['$message'].success('修改成功!')
      this.cancelEditForm()
    } else {
      this['$message'].error('修改失败!')
    }
  }
  deleteSearch() {
    this.$confirm('确认删除该数据?', '提示', {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(async() => {
        let res: any = await deleteSearch(this.deleteParams)
        if (res.status.code === 0) {
          this['$message'].success('删除成功!')
          setTimeout(() => {
            this.getTableData()
          }, 1000)
        } else {
          this['$message'].error('删除失败!')
        }
      })
      .catch(() => {})
  }
  handleDateChange(date: string[]) {
    this.params.updateDateStart = date && date[0]
    this.params.updateDateEnd = date && date[1]
  }
  setTableHeight() {
    const filter: any = this.$refs.filter
    const filterDom: any = filter.$el
    this.tableHeight = document.body.clientHeight - 250 - filterDom.clientHeight
  }
  handleSearch() {
    if (this.tableLoading) { return false }
    let params:any = { ...this.params }
    for (let i in params) {
      if (typeof params[i] === 'string') {
        params[i] = params[i].trim()
      }
    }
    this.params = params
    this.params.page = 1
    this.getTableData()
  }
  handleReset() {
    resetObjValue2NoneString(this.params, ['page', 'pageCount', 'from'])
    this.dateArray = ['', '']
    this.params.page = 1
    this.getTableData()
  }
  goToDetail(item: ISearchRes) {
    this.routeQuery = {
      id: item.id,
      platform: 'android'
    }
    this.openWindow({
      name: 'AppDetail',
      query: this.routeQuery
    })
  }
  handleSelectionChange(list: ISearchRes[]) {
    this.selectedData = list
  }
  handleSelectReverse() {
    this.selectedData = []
    let tempList: number[] = []
    let tempSelectList: number[] = []
    let indexList: number[] = []
    tempList = this.tableData.map(item => item.id)
    tempSelectList = this.selectedData.map(item => item.id)
    indexList = tempList.filter(item => !tempSelectList.includes(item))
    this.tableData.forEach(item => {
      if (indexList.includes(item.id)) this.selectedData.push(item)
    })

    // this.selectedData = this.tableData.filter(item => indexList.includes(item.id))
    if (this.selectedData.length) {
      this.selectedData.forEach(row => {
        (this.$refs['multiTable'] as any).toggleRowSelection(row)
      })
    } else {
      (this.$refs['multiTable'] as any).clearSelection()
    }
  }
  removeApp(item: ISearchRes) {
    this.deleteParams.ids = item.id.toString()
    this.deleteParams.from = 'all'
    this.deleteSearch()
  }
  handleRemoveAll() {
    let t: number[] = []
    this.selectedData.forEach(item => {
      t.push(item.id)
    })
    this.deleteParams.ids = t.join(',')
    this.deleteSearch()
  }
  handleEditAll() {
    this.editFormVisible = true
    let t: number[] = []
    this.selectedData.forEach(item => {
      t.push(item.id)
    })
    this.deleteParams.from = this.params.from
    this.editParams.ids = t.join(',')
  }
  handleAdd() {
    let routeQuery: any = {
      platform: 'android'
    }
    this.openWindow({
      name: 'AddApp',
      query: routeQuery
    })
  }
  cancelAddForm() {
    (this.$refs['addParams'] as Form).resetFields()
    this.addFormVisible = false
  }
  confirmAddForm() {
    (this.$refs['addParams'] as Form).validate(valid => {
      if (valid) {
        this.addSearch()
      } else {
        this['$message'].warning('请填写缺失参数!')
        return false
      }
    })
  }
  editApp(item: ISearchRes) {
    let routeQuery: any = {
      platform: 'android',
      id: item.id
    }
    this.openWindow({
      name: 'EditApp',
      query: routeQuery
    })
  }
  cancelEditForm() {
    (this.$refs['editParams'] as Form).resetFields()
    this.editFormVisible = false
  }
  confirmEditForm() {
    (this.$refs['editParams'] as Form).validate(valid => {
      if (valid) {
        if (
          this.editParams.weightLevel.toString() === '1' &&
          this.editParams.weight
        ) {
          this.updateWeight(this.editParams.weight)
        } else if (this.editParams.weightLevel.toString() !== '1') {
          this.updateWeight(this.editParams.weight)
        } else {
          this['$message'].warning('请填写自定义权重!')
        }
      } else {
        this['$message'].warning('请填写缺失参数!')
      }
    })
  }
  // computed
  get showMultiSelect() {
    return this.selectedData.length > 1
  }
  get selectCount() {
    return this.selectedData.length
  }
}
